import i18next from 'i18next';
import * as React from 'react';
import { Button, IconButton, Link } from 'src/components/atoms';
import '../../../css/public/ResponsiveContainer.css';
import CircleButton from '../../atomsLegacy/buttons/CircleButton';
import ShadowContainer from '../../atomsLegacy/containers/ShadowContainer';

interface Props {
  includeLeftCircleButton: boolean;
  includeRightCircleButton: boolean;
  includeCloseCircleButton?: boolean;
  includeBottomButton: boolean;
  backLinkTo?: string;
  nextLinkTo?: string;
  nextLinkDisabled?: boolean;
  buttonText?: string;
  buttonStyles?: React.CSSProperties;
  backButtonOnClick?(): void;
  nextButtonOnClick?(): void;
  validate?: () => boolean;
  loggedInUser?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
  setMinHeight?: boolean;
}

const ResponsiveContainer = (props: Props) => {
  const to = () => {
    if (props.nextLinkDisabled) {
      return '#';
    }

    if (props.nextLinkTo === undefined) {
      return '#';
    }

    if (props.validate !== undefined && !props.validate()) {
      return '#';
    }

    return props.nextLinkTo;
  };

  const direction = i18next.dir ? i18next.dir() : 'ltr';

  return (
    <ShadowContainer
      loggedIn={props.loggedInUser}
      setMinHeight={props.setMinHeight}
    >
      {props.includeCloseCircleButton && (
        <div
          style={{ right: '-20px', top: '-15px' }}
          className="responsive-container-circle-button"
        >
          <Link to={props.backLinkTo || '#'}>
            <CircleButton direction="close" onClick={() => {}} />
          </Link>
        </div>
      )}
      {props.includeLeftCircleButton && (
        <div
          style={direction === 'ltr' ? { left: '-35px' } : { right: '-35px' }}
          className="responsive-container-circle-button"
        >
          <Link to={props.backLinkTo || '#'} data-testid="report-back">
            <IconButton
              size="large"
              variant="primary"
              data-testid="report-back-button"
              iconName={
                direction === 'ltr' ? 'uil-angle-left-b' : 'uil-angle-right-b'
              }
              circular
              fontSize="32px"
              onClick={() => {
                if (props.backButtonOnClick) {
                  props.backButtonOnClick();
                }
              }}
            />
          </Link>
        </div>
      )}
      {props.includeRightCircleButton && (
        <div
          style={direction === 'ltr' ? { right: '-35px' } : { left: '-35px' }}
          className="responsive-container-circle-button"
        >
          <Link to={to()} data-testid="report-next">
            <IconButton
              size="large"
              variant="primary"
              data-testid="report-next-button"
              iconName={
                direction === 'ltr' ? 'uil-angle-right-b' : 'uil-angle-left-b'
              }
              circular
              disabled={props.nextLinkDisabled}
              fontSize="32px"
              onClick={() => {
                if (!props.nextLinkDisabled && props.nextButtonOnClick)
                  props.nextButtonOnClick();
              }}
            />
          </Link>
        </div>
      )}

      {props.children}

      {props.includeBottomButton && (
        <div className="responsive-container-btn">
          <div
            tabIndex={0}
            onKeyPress={(event) => {
              if (
                event.key === 'Enter' &&
                !props.nextLinkDisabled &&
                props.nextButtonOnClick
              ) {
                props.nextButtonOnClick();
              }
            }}
          >
            <Link
              to={to()}
              className="responsive-container-btn-link"
              data-testid="open-report-container-link"
            >
              <Button
                variant="primary"
                size="medium"
                data-testid="open-report-container-button"
                disabled={props.nextLinkDisabled}
                width="140px"
                onClick={() => {
                  if (!props.nextLinkDisabled && props.nextButtonOnClick)
                    props.nextButtonOnClick();
                }}
              >
                {props.buttonText || ''}
              </Button>
            </Link>
          </div>
        </div>
      )}
    </ShadowContainer>
  );
};

export default ResponsiveContainer;
